// React
import { useEffect, useState } from "react"

// Types
import type { SuccessFetch } from "types"
import type { DataListType, ListType } from "../../types"

// Utils
import { useApi } from "utils"

export function useAllCoaList(): ListType {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<DataListType[]>([])
  const [isLoading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    api.get(
      "/coa/"
    ).then((res: SuccessFetch<{
      payload: DataListType[]
    }>) => {
      setData(res.data.payload.map(item => ({
        coa_id: item.coa_id,
        opening_balance: item.opening_balance,
        parent_id: item.parent_id
      })))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })

    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  // Functions
  const getParentList = (coa_id: number): number[] => {
    // Vars
    const selectedCoa: number[] = [coa_id]
    data.forEach(item => {
      if (item.parent_id && selectedCoa.includes(item.parent_id)) {
        selectedCoa.push(item.coa_id)
      }
    })
    
    return selectedCoa
  }
  const getOpeningBalance = (coa_id: number): number => {
    // Vars
    const parentList = getParentList(coa_id)

    return data.filter(item => {
      // Vars
      const parent_id = item.parent_id

      return parent_id && parentList.includes(parent_id)
    }).reduce((acc, item) => {
      return acc + item.opening_balance
    }, 0) ?? 0
  }

  return { data, isLoading, getOpeningBalance }
}